import axios from 'axios';
import {
  FETCH_NOTIFICATION_BADGES,
  NOTIFICATION_BADGE_SUCCESS,
  NOTIFICATION_BADGE_ERROR,
} from '../actions/notifications';

const state = {
  badges: {
    messages: 0,
    // Open tickets Clara handed over (ASAP); counted apart from `messages`.
    requestsAsap: 0,
    claims: 0,
    leads: 0,
    tasks: 0,
    renewals: 0,
    payments: 0,
    companyProfile: false,
    teamLimitExceeded: false,
  },
  status: '',
};

const getters = {
  notificationBadges: (state) => state.badges,
};

const actions = {
  [FETCH_NOTIFICATION_BADGES]: ({ commit }) => {
    commit(FETCH_NOTIFICATION_BADGES);
    return axios.post('/insurance/notification/badge', {})
      .then((resp) => {
        commit(NOTIFICATION_BADGE_SUCCESS, resp.data);
        return resp;
      })
      .catch((err) => {
        commit(NOTIFICATION_BADGE_ERROR);
        return Promise.reject(err);
      });
  },
};

const mutations = {
  [FETCH_NOTIFICATION_BADGES]: (state) => {
    state.status = 'loading';
  },
  [NOTIFICATION_BADGE_SUCCESS]: (state, badges) => {
    state.status = 'success';
    state.badges = badges;
  },
  [NOTIFICATION_BADGE_ERROR]: (state) => {
    state.status = 'error';
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
